import React from "react";
import { observer } from "mobx-react";
import { Button, Dropdown, Menu } from "antd";
import {
    UploadOutlined,
    FileExcelOutlined,
    FileTextOutlined,
    CloudUploadOutlined,
} from "@ant-design/icons";
import { useParams } from "react-router-dom";
import CitationBulkUploadModal from "./bulk-upload-modal";
import CitationBulkUploadResultsModal from "./bulk-upload-results-modal";
import citationBulkUploadStore from "@app/state/store/citation/bulk-upload";

const CitationBulkUploadProgress = observer(() => {
    const { uploads, progress, isLoading } = citationBulkUploadStore;
    const hasUploads = uploads.length > 0;
    const allComplete = uploads.every(
        (upload) => !["loading", "queued", "processing"].includes(upload.status),
    );

    if (allComplete && hasUploads) {
        return (
            <div>
                <Button onClick={() => citationBulkUploadStore.toggleResultsModal(true)}>
                    Upload complete. Show Results
                </Button>
                <CitationBulkUploadResultsModal />
            </div>
        );
    }

    if (!isLoading && !hasUploads) {
        return null;
    }

    return <Button>Upload in progress: {progress}%</Button>;
});

const ReferenceMenu = observer(() => {
    const { project } = useParams();

    const menu = (
        <Menu>
            <Menu.Item key="pdf">
                <Button
                    type="text"
                    icon={<CloudUploadOutlined />}
                    onClick={() => {
                        citationBulkUploadStore.toggleModal(true);
                        citationBulkUploadStore.projectId = project;
                        citationBulkUploadStore.activeTab = "pdf";
                    }}
                >
                    Bulk Upload PDFs
                </Button>
            </Menu.Item>
            <Menu.Item key="ris">
                <Button
                    type="text"
                    icon={<FileTextOutlined />}
                    onClick={() => {
                        citationBulkUploadStore.toggleModal(true);
                        citationBulkUploadStore.projectId = project;
                        citationBulkUploadStore.activeTab = "ris";
                    }}
                >
                    Import RIS File
                </Button>
            </Menu.Item>
            <Menu.Item key="excel">
                <Button
                    type="text"
                    icon={<FileExcelOutlined />}
                    onClick={() => {
                        citationBulkUploadStore.toggleModal(true);
                        citationBulkUploadStore.projectId = project;
                        citationBulkUploadStore.activeTab = "excel";
                    }}
                >
                    Import Excel File
                </Button>
            </Menu.Item>
        </Menu>
    );

    return (
        <>
            <Dropdown overlay={menu} trigger={["click"]}>
                <Button style={{ marginRight: 8 }}>
                    Import <UploadOutlined />
                </Button>
            </Dropdown>
            <CitationBulkUploadModal />
            <CitationBulkUploadProgress />
        </>
    );
});

export default ReferenceMenu;
